import React from 'react';
import { BookOpenIcon, GiftIcon, GlobeIcon, LockIcon } from 'lucide-react';
import { images } from '../../data/content';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
const stack = [{
  icon: BookOpenIcon,
  title: 'The Sensory Clinical Route™',
  detail: '6 Premium Volumes',
  value: 97
}, {
  icon: GiftIcon,
  title: '5 Professional Bonuses',
  detail: 'Question Vault, Organizer, Checkpoints, Challenges & Tracker',
  value: 147
}];
export function Offer() {
  return <section id="offer" className="bg-brand-dark px-4 py-16 sm:py-24" aria-labelledby="offer-title" data-id="element-206" data-mp="3f2ffks8rmdgy">
      <div className="mx-auto max-w-2xl" data-id="element-207" data-mp="3jxcvmj4gpn3c">
        <p className="text-center text-xs font-bold uppercase tracking-[0.18em] text-gold sm:text-sm" data-id="element-208" data-mp="3nx3jof2ltp46">Special launch offer</p>
        <h2 id="offer-title" className="mt-3 text-center font-serif text-[30px] font-bold leading-[1.15] text-white sm:text-5xl" data-id="element-209" data-mp="3sx9da0sfplow">
          Here’s everything you’ll receive today
        </h2>

        <div className="mt-10 overflow-hidden rounded-3xl bg-white" data-id="element-210" data-mp="1km9kmzrjfzrz">
          <img src={images.mainMockup} alt="Everything included in the Sensory Clinical Route™" className="block w-full bg-cream" loading="lazy" data-id="element-211" data-mp="1flvnicrh6a8q" />

          <div className="px-5 pb-8 pt-6 sm:px-8" data-id="element-212" data-mp="1bl1z7ia4etfb">
            <ul className="divide-y divide-sand" data-id="element-213" data-mp="16m8i7fvmkkae">
              {stack.map(({
              icon: Icon,
              title,
              detail,
              value
            }) => <li key={title} className="flex items-center gap-4 py-4" data-id="element-214" data-mp="23awo5du2gh3g">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-soft text-brand" data-id="element-215" data-mp="1z9uncski3wzd">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-216" data-mp="1uicxazk0ngt6" />
                  </span>
                  <div className="min-w-0 flex-1" data-id="element-217" data-mp="1pji55705sfwe">
                    <p className="font-bold text-ink" data-id="element-218" data-mp="1piqi4kkmnqhq">{title}</p>
                    <p className="text-sm leading-snug text-muted" data-id="element-219" data-mp="2n1i62n7m01qk">{detail}</p>
                  </div>
                  <span className="shrink-0 text-sm font-bold text-muted" data-id="element-220" data-mp="2i7nrfy6v2cyc">
                    Value <s className="text-alert" data-id="element-221" data-mp="316iioj1r2kfz">${value}</s>
                  </span>
                </li>)}
            </ul>

            <div className="mt-2 flex items-center justify-between rounded-xl bg-sand px-4 py-3" data-id="element-222" data-mp="366oco5vhsj18">
              <span className="text-sm font-bold uppercase tracking-wide text-ink" data-id="element-223" data-mp="2sb2twgfuqvh9">Total value</span>
              <s className="text-lg font-bold text-alert" data-id="element-224" data-mp="2wcnyzfm5a5gw">USD $244</s>
            </div>

            <div className="mt-8 text-center" data-id="element-225" data-mp="2idoduhxuc8ph">
              <p className="text-[16px] text-muted" data-id="element-226" data-mp="2neltamrguona">But you don’t need to pay $244. Today, the complete system is only:</p>
              <p className="mt-2 font-serif text-7xl font-extrabold leading-none text-cta-dark sm:text-8xl" data-id="element-227" data-mp="29fcoskcmhiz5">
                <span className="align-top text-2xl font-bold sm:text-3xl" data-id="element-228" data-mp="2dgo8yacq9bzy">USD $</span>27
              </p>
              <p className="mt-3 text-sm font-semibold text-ink" data-id="element-229" data-mp="7ng1kdh3ekoj">One-time payment · No monthly subscription · Lifetime access</p>
              <p className="mx-auto mt-3 flex max-w-sm items-start justify-center gap-2 rounded-xl bg-brand-soft px-3 py-2.5 text-[13px] font-medium leading-snug text-brand-dark" data-id="element-230" data-mp="bm71stguuifv">
                <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-231" data-mp="1s6tm57xjdvke" />
                Currency conversion is automatic — you’ll see the price in your local currency at checkout.
              </p>
            </div>

            <div className="mt-7" data-id="element-232" data-mp="2fujj096omuo0">
              <CTAButton label="Get the Sensory Clinical Route™" showSubtext data-id="element-233" data-mp="2fti9wa988i8x" />
            </div>

            <Countdown data-id="element-234" data-mp="2auf2ij5rxzxs" />
            <ScarcityBar data-id="element-235" data-mp="2auyj9wjouia8" />

            <p className="mt-5 flex items-center justify-center gap-1.5 text-xs font-medium text-muted" data-id="element-236" data-mp="2axt43p6m6546">
              <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-237" data-mp="2jw54uk172jac" />
              Secure checkout · Limited promotional price
            </p>
          </div>
        </div>

        <p className="mt-8 text-center text-[16px] leading-relaxed text-brand-light" data-id="element-238" data-mp="uhgs2hooyzbs">
          For less than the cost of many professional reference materials, you’ll have a practical clinical route you can return to whenever you know what you’ve found — but aren’t sure what to do next.
        </p>
      </div>
    </section>;
}